<div class="h-100 w-100 p-2">
  <h5>Based on the class you chose, choose your starting equipment from the choices below.</h5>
  <div class="d-flex justify-content-between h-100 w-100 mt-1 pb-3">
    <div class="custom-scrollbar border p-2 w-100" style="height: 96%;">
      <h3 class="text-center mb-1">Equipment Choices</h3>
      <mat-tab-group mat-align-tabs="center" [disableRipple]="true" [(selectedIndex)]="tabIndex" class="w-100">
        <div *ngFor="let choiceList of choices | keyvalue, let i = Index" class="h-50 mb-3">
          <mat-tab [label]="choiceList.key">
            <div class="d-flex justify-content-between border p-2 h-100">
              <div *ngFor="let choice of choiceList.value" class="h-100 custom-scrollbar">
                <h6>Choose {{choice['choose']}} from</h6>
                <app-item [items]="choice['items']" [characterCreate]="true" (addedItem)="addItem($event)"></app-item>
              </div>
            </div>
          </mat-tab>
        </div>
      </mat-tab-group>
      <button (click)="saveItems()" class="btn btn-sm btn-main float-right align-self-end mt-2 mb-2" id="saveItemsButton">
        Save Items
      </button>
    </div>
    <!--    <div class="custom-scrollbar border p-2" style="width: 49%; height: 96%">-->
    <!--      <h3 class="text-center mb-1">Selected Equipment</h3>-->
    <!--      <div *ngIf="selectedItems">-->
    <!--        <div *ngFor="let item of selectedItems" class="card w-100 mt-1" style="height: 45px">-->
    <!--          <strong class="ml-2 my-auto">{{item.name}}</strong>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <button (click)="saveItems()" class="btn btn-sm btn-main float-right align-self-end" id="nextButton">Save Items-->
    <!--      </button>-->
    <!--    </div>-->
  </div>
</div>
